import { extendTheme } from '@chakra-ui/react';

export const baseChakraTheme = extendTheme({
  styles: {
    global: {
      body: {
        fontFamily: 'Latitude sans',
        color: '#0B2374',
      },
    },
  },
  Component: {
    ChText: {
      color: '#0B2374',
    },
  },
});
